import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button";
import FileUploader from "../../../components/FileUploader";
import SellModal from "../../../containers/Sell/SellModalContainer";
import { PictureProps } from "../../../interfaces/pages";
import styles from "./pictures.module.scss";
import { trackEvent } from "../../../config/firebase";


const Pictures = ({
    postPublicationsImages,
    deletePublicationImage,
    fetchingDeleteImage,
    cleanDeleteImage,
    imagesVideos,
    setImages,
    plate,
    isFoundPlate
}: PictureProps) => {
    const navigate = useNavigate();
    const [disabledButton, setDisabledButton] = useState<boolean>(false);
    const MAX_IMAGES = 15; // máximo de imágenes permitidas

    const onChangeFileUploader = (files: any) => {
        // Filtramos solo las imágenes que no están marcadas para eliminar
        const activeFiles = files && files.filter((item: any) => !item?.toDelete);
        
        // Verificamos si hay menos de 3 imágenes (mínimo requerido)
        setDisabledButton(activeFiles.length < 3);
        
        // Si hay más del máximo permitido, cortamos el array
        if (activeFiles.length > MAX_IMAGES) {
            const filesToKeep = files.filter((item: any) => !item?.toDelete).slice(0, MAX_IMAGES);
            const filesToDelete = files.filter((item: any) => item?.toDelete);
            setImages([...filesToKeep, ...filesToDelete]);
            return;
        }
        
        setImages(files);
        files && files.forEach(async (file: any) => {
            if (file.toDelete) {
                deletePublicationImage(file?.id);
                return;
            }
            if (file?.previewURL) {
                let formData = new FormData();
                formData.append("file", file?.file, file?.name);
                postPublicationsImages(formData, file?.id);
            }
        })
    }

    const onPressNext = () => {
        navigate("/vender-auto/valor-y-pago");
    };

    const disabled = useMemo(() => {
        let isDisabled = false;
        const foundedOne = imagesVideos && imagesVideos.find((image: any) => image?.upload === "loading" || image?.upload === "failure");
        if (foundedOne || imagesVideos.length < 3) {
            isDisabled = true;
        }
        return isDisabled;
    }, [imagesVideos]);

    // Verificar si se ha alcanzado el límite máximo de imágenes
    const maxImagesReached = useMemo(() => {
        const activeImages = imagesVideos && imagesVideos.filter((item: any) => !item?.toDelete);
        return activeImages.length >= MAX_IMAGES;
    }, [imagesVideos]);

    useEffect(() => {
        if (fetchingDeleteImage === "failure") {
            cleanDeleteImage();
        }
        if (fetchingDeleteImage === "success") {
            cleanDeleteImage();
        }
    }, [fetchingDeleteImage]);

    useEffect(() => {
        if (!plate) return navigate("/vender-auto");
        trackEvent("venta-paso-imagenes")
    }, []);

    return (
        <SellModal
            step={isFoundPlate ? 6 : 8}
            title="Añadir fotos"
            subTitle={`Debes añadir mínimo 3 fotos (máximo ${MAX_IMAGES})`}
            onClickBack={() => navigate("/vender-auto/descripcion")}
           
        >
            <p className={styles.text}>Tamaño máximo por foto: 10mb</p>
            <div className={`${styles.inputsContainer} ${imagesVideos.length === 0 && styles.noImages}`}>
                <FileUploader
                    values={imagesVideos}
                    onChange={onChangeFileUploader}
                    className={styles.fileUploader}
                    scroll={imagesVideos.length > 0}
                    disabled={maxImagesReached}
                />
            </div>
            
            {/* Mostramos el mensaje de advertencia entre el contenedor de imágenes y el botón */}
            {maxImagesReached && (
                <div className={styles.warningContainer}>
                    <p className={styles.maxImagesWarning}>Has alcanzado el límite máximo de {MAX_IMAGES} fotos.</p>
                </div>
            )}
            
            <Button
                onPress={onPressNext}
                title="Continuar"
                primary
                disabled={disabled || disabledButton}
                className={styles.submitButton}
            />
        </SellModal>
    )
};

export default Pictures;